import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import { TFunction } from "i18next";

import { DATE_VALUE_FORMAT } from "../../../../utils/portalDateFormat";

dayjs.extend(customParseFormat);
dayjs.extend(utc);

// EN-5192: date of birth is ward-configurable. An empty date is only an error when the ward
// requires it. Kept outside the component so the submit handler (declared above the ward-config
// memos) can call it without depending on declaration order.
// EN-5272: the value is the picker's `YYYY-MM-DD` (or "" when unset). The picker only commits a
// real date and greys out future days, but a future date is still rejected here so the rule does
// not rest on the calendar alone.
export function getDateOfBirthError(
  value: string,
  isShown: boolean,
  isRequired: boolean,
  t: TFunction
): string {
  if (!isShown) return "";

  if (value === "") {
    return isRequired ? t("addPatient_validation_dateRequired") : "";
  }

  const date = dayjs(value, DATE_VALUE_FORMAT, true);

  if (!date.isValid()) {
    return t("addPatient_validation_dateInvalid");
  }

  if (date.isAfter(dayjs(), "day")) {
    return t("addPatient_validation_datePast");
  }

  return "";
}

// DOB is a calendar date — parse it as UTC so the stored date part is independent of the user's
// timezone. EN-5192: it can be hidden or left blank, so null rather than an "Invalid Date" when
// there is nothing to parse.
export function toDateOfBirthPayload(value: string): string | null {
  const parsed = dayjs.utc(value, DATE_VALUE_FORMAT, true);

  return parsed.isValid() ? parsed.toISOString() : null;
}
